const { useState, useEffect, useRef } = React;

const ANNOUNCEMENT_MAX_LENGTH = 500;

function coerceToSoldOutArray(val) {
  if (Array.isArray(val)) return val;
  if (val && typeof val === 'object') {
    return Object.keys(val)
      .sort((a, b) => (Number(a) || 0) - (Number(b) || 0))
      .map(k => val[k]);
  }
  return [];
}

function normalizeSoldOutIds(input) {
  const raw = coerceToSoldOutArray(input).filter(x => x !== '' && x != null);
  const seen = new Set();
  const out = [];
  for (const id of raw) {
    const key = String(id);
    if (seen.has(key)) continue;
    seen.add(key);
    if (typeof id === 'number') out.push(id);
    else if (/^\d+$/.test(key)) out.push(Number(key));
    else out.push(id);
  }
  return out;
}

function normalizeCustomMenus(input) {
  if (!input || typeof input !== 'object') return {};
  const normalized = {};
  Object.entries(input).forEach(([category, items]) => {
    const categoryItems = Array.isArray(items) ? items : items && typeof items === 'object'
      ? Object.keys(items)
      .sort((a, b) => (Number(a) || 0) - (Number(b) || 0))
      .map(key => items[key])
      : [];
    categoryItems.forEach(item => {
      const itemCategory = item && item.category ? item.category : category;
      if (!normalized[itemCategory]) normalized[itemCategory] = [];
      normalized[itemCategory].push(item && item.category ? item : { ...item, category: itemCategory });
    });
  });
  return normalized;
}

const MENU_DATA = {
  "떡볶이": [
    { id: 1, name: "신전떡볶이", price: 4000, hasOptions: true, tteokCount: 1, image: "img/1280_1280_떡볶이_흰색.webp" },
    { id: 2, name: "치즈떡볶이", price: 6000, hasOptions: true, tteokCount: 1, image: "img/1280_1280_치즈떡볶이_흰색.webp" },
    { id: 3, name: "로제떡볶이", price: 6000, hasOptions: true, tteokCount: 1, image: "img/1280_1280_로제떡볶이_흰색.webp" }
  ],
  "튀김류": [
    { id: 10, name: "튀김오뎅(5개)", price: 1700, image: "img/1280_1280_튀김오뎅_흰색.webp" },
    { id: 11, name: "튀김만두(5개)", price: 1700, image: "img/1280_1280_튀김만두_흰색.webp" },
    { id: 12, name: "김말이(3개)", price: 1700, image: "img/1280_1280_김말이튀김_흰색.webp" },
    { id: 13, name: "잡채말이(3개)", price: 1700, image: "img/1280_1280_잡채말이_흰색.webp" },
    { id: 15, name: "모둠튀김", price: 4500, image: "img/1280_1280_모둠튀김_흰색.webp" },
    { id: 101, name: "통큰너겟(2개)", price: 2000, image: "img/1280_1280_치킨링.webp" },
    { id: 18, name: "고추튀김(2개)", price: 2500, image: "img/1280_1280_한입고추튀김_흰색.webp" },
    { id: 16, name: "치즈스틱(3개)", price: 2000, image: "img/1280_1280_치즈스틱_흰색.webp" },
    { id: 102, name: "납작만두(5개)", price: 2000, image: "img/1280_1280_납작만두.webp" },
    { id: 103, name: "해쉬브라운(2개)", price: 2500, image: "img/1280_1280_해쉬브라운_흰색.webp" },
    { id: 14, name: "오징어튀김(2개)", price: 2000, image: "img/1280_1280_오징어튀김_흰색.webp" },
    { id: 104, name: "단호박튀김(3개)", price: 2000, image: "img/1280_1280_단호박튀김_흰색.webp" },
    { id: 19, name: "치킨텐더(3개)", price: 2500, image: "img/1280_1280_치킨텐더_흰색.webp" },
    { id: 105, name: "크림치즈볼(4개)", price: 2500, image: "img/1280_1280_크림치즈볼_흰색.webp" },
    { id: 106, name: "고구마치즈볼(4개)", price: 2500, image: "img/1280_1280_고구마치즈볼_흰색.webp" },
    { id: 107, name: "닭껍질튀김(100g)", price: 2500, image: "img/1280_1280_닭껍질튀김_흰색.webp" },
    { id: 108, name: "통살오징어(3개)", price: 2900, image: "img/1280_1280_통살오징어_흰색.webp" },
    { id: 17, name: "치킨링(10개)", price: 2200, image: "img/1280_1280_치킨링.webp" }
  ],
  "김밥&컵밥류": [
    { id: 20, name: "참치김치컵밥", price: 3000, image: "img/1280_1280_신전라이스.webp" },
    { id: 21, name: "치킨마요컵밥", price: 4000, image: "img/1280_1280_치킨마요컵밥_흰색.webp" },
    { id: 22, name: "스팸마요컵밥", price: 4000, image: "img/1280_1280_스팸마요컵밥_흰색.webp" },
    { id: 23, name: "참치마요컵밥", price: 4000, image: "img/1280_1280_참치마요컵밥_흰색.webp" },
    { id: 24, name: "신전김밥", price: 3000, image: "img/1280_1280_신전김밥_흰색.webp" },
    { id: 25, name: "신전치즈김밥", price: 4000, image: "img/1280_1280_신전김밥_흰색.webp" }
  ],
  "세트메뉴": [
    { id: 30, name: "SET 1(떡1+모둠튀김+쿨피스)", price: 10000, hasOptions: true, tteokCount: 1, image: "img/1280_1280_모둠튀김_흰색.webp" },
    { id: 31, name: "SET 2(떡1+오뎅5+만두5+김말이3+잡채3+텐더+쿨피스)", price: 14800, hasOptions: true, tteokCount: 1, image: "img/1280_1280_모둠튀김_흰색.webp" },
    { id: 32, name: "SET 3(떡2+오뎅10+만두10+김말이6+쿨피스)", price: 19700, hasOptions: true, tteokCount: 2, image: "img/1280_1280_모둠튀김_흰색.webp" },
    { id: 33, name: "신전 SET(떡2+오뎅15+만두15+잡채9+쿨피스)", price: 24300, hasOptions: true, tteokCount: 2, image: "img/1280_1280_모둠튀김_흰색.webp" },
    { id: 34, name: "스페셜 SET(떡2+오뎅15+만두10+김말이6+잡채6+텐더+쿨피스)", price: 29700, hasOptions: true, tteokCount: 2, image: "img/1280_1280_모둠튀김_흰색.webp" }
  ],
  "사이드": [
    { id: 40, name: "삶은계란(2개)", price: 1500, image: "img/1280_1280_계란.webp" },
    { id: 41, name: "쿨피스", price: 2000, image: "img/1280_1280_쥬시쿨.webp" },
    { id: 43, name: "단무지", price: 500, image: "img/1280_1280_단무지_흰색.webp" },
    { id: 44, name: "순대", price: 4000, image: "img/1280_1280_순대_흰색.webp" }
  ]
};

const TOPPINGS_DATA = [
  { id: 't1', name: "치즈 추가", price: 2000, image: "img/1280_1280_치즈토핑_흰색.webp" },
  { id: 't2', name: "납작면", price: 2000, image: "img/1280_1280_납작면.webp" },
  { id: 't3', name: "비엔나(5개)", price: 1000, image: "img/1280_1280_비엔나_흰색.webp" }
];

const SAUCE_TYPES = [
  { id: 's1', name: "순한맛", linkedMenus: [1, 2, 3] },
  { id: 's2', name: "중간맛", linkedMenus: [1, 2, 3] },
  { id: 's3', name: "매운맛", linkedMenus: [1, 2, 3] },
  { id: 's4', name: "로제", linkedMenus: [3] }
];

function App() {
  // URL ?o=secureId 파라미터로 주문 조회 모드 감지
  const urlOrderId = new URLSearchParams(window.location.search).get('o');

  const [currentCat, setCurrentCat] = useState("떡볶이");
  const [cart, setCart] = useState([]);
  const [orders, setOrders] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [spicyList, setSpicyList] = useState([""]);
  const [toppingQtysList, setToppingQtysList] = useState([{ t1: 0, t2: 0, t3: 0 }]);
  const [modalQty, setModalQty] = useState(1);
  const [tempQtys, setTempQtys] = useState({});
  const [lastOrderNo, setLastOrderNo] = useState(() => localStorage.getItem('lastOrderNo'));
  const [orderType, setOrderType] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [userInfo, setUserInfo] = useState({ phone: '', address: '', detailAddress: '', privacyAgreed: false });
  const [pendingOrderType, setPendingOrderType] = useState(null);
  const [showTakeoutConfirm, setShowTakeoutConfirm] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const [storeSettings, setStoreSettings] = useState({
    openTime: "11:00",
    closeTime: "22:00",
    breakStartTime: "15:00",
    breakEndTime: "17:00",
    isTemporaryPaused: false,
    discounts: {
      'dine-in': { minAmount: 0, discountValue: 0 },
      'takeout': { minAmount: 0, discountValue: 0 },
      'takeout-reservation': { minAmount: 0, discountValue: 0 },
      'delivery': { minAmount: 0, discountValue: 0 }
    },
    deliveryFees: [
      { minAmount: 0, fee: 3000 },
      { minAmount: 15000, fee: 2000 },
      { minAmount: 30000, fee: 0 }
    ],
    minDeliveryAmount: 0
  });
  const [soldOutIds, setSoldOutIds] = useState([]);
  const [menuNames, setMenuNames] = useState({});
  const [customMenus, setCustomMenus] = useState({});
  const [announcement, setAnnouncement] = useState('');
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
  const [shopStatus, setShopStatus] = useState({ isOpen: true, message: "" });
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showOrderConfirm, setShowOrderConfirm] = useState(false);
  const [lastOrderType, setLastOrderType] = useState(null);
  const [showOriginModal, setShowOriginModal] = useState(false);
  const [originInfo, setOriginInfo] = useState('');
  const [menuPrices, setMenuPrices] = useState({}); // Firebase에서 덮어쓸 가격 {id: price}
  const [disposableUtensils, setDisposableUtensils] = useState(false);
  const [tteokPackaging, setTteokPackaging] = useState('separate');
  const [deliveryToast, setDeliveryToast] = useState(null);
  const [authUser, setAuthUser] = useState(null);
  const [authError, setAuthError] = useState(null);

  // 실제 렌더링에 사용할 메뉴 (가격 오버라이드 + 커스텀 메뉴 병합)
  const getMenuData = () => {
    const result = {};
    // 기본 메뉴 + 가격 오버라이드 적용
    Object.entries(MENU_DATA).forEach(([cat, items]) => {
      result[cat] = items.map(item =>
        menuPrices[item.id] !== undefined ? { ...item, price: menuPrices[item.id] } : item
      );
    });
    // 커스텀 메뉴 추가
    Object.entries(normalizeCustomMenus(customMenus)).forEach(([cat, customItems]) => {
      if (!result[cat]) result[cat] = [];
      customItems.forEach((item, idx) => {
        const customId = item.id || `custom-${cat}-${idx}`;
        result[cat].push({
          id: customId,
          name: menuNames[customId] || item.name,
          price: menuPrices[customId] !== undefined ? menuPrices[customId] : item.price,
          image: item.image || null
        });
      });
    });
    return result;
  };
  const currentMenuData = getMenuData();

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallBanner(true);
    });
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('./sw.js')
        .then(reg => console.log('SW Registered'))
        .catch(err => console.log('SW Error', err));
    }

    // 인증 상태 감시
    const unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {
      setAuthUser(user);
      if (user) {
        setAuthError(null);
      }
    });

    return () => {
      unregisterAuthObserver();
    };
  }, []);

  const handleInstall = () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then(() => {
      setDeferredPrompt(null);
      setShowInstallBanner(false);
    });
  };

  const handleAddressSearch = () => {
    new daum.Postcode({
      oncomplete: function (data) {
        if (!data.address.includes('홍성읍')) {
          alert('홍성읍 지역만 배달 가능합니다.');
          return;
        }
        setUserInfo(prev => ({ ...prev, address: data.address }));
      }
    }).open();
  };

  const signInWithGoogle = async () => {
    try {
      await window.signInWithGoogle();
    } catch (error) {
      setAuthError(error.message || '로그인 실패');
      console.error('로그인 실패', error);
    }
  };

  const signOut = async () => {
    try {
      await window.signOutFirebase();
      setAuthUser(null);
    } catch (error) {
      setAuthError(error.message || '로그아웃 실패');
      console.error('로그아웃 실패', error);
    }
  };

  const fetchOrders = () => {
    try {
      ordersRef.on('value', (snapshot) => {
        const data = snapshot.val();
        let ordersArray = [];
        if (data && Array.isArray(data)) {
          ordersArray = data;
        } else if (data) {
          ordersArray = Object.values(data);
        }
        setOrders(ordersArray);
        localStorage.setItem('orders_backup', JSON.stringify(ordersArray));
      }, (error) => {
        console.error("Firebase 데이터 로드 실패:", error);
      });
    } catch (e) {
      console.error("주문 데이터 로드 실패:", e);
    }
  };

  const fetchStoreSettings = () => {
    try {
      settingsRef.on('value', (snapshot) => {
        const data = snapshot.val();
        if (data) {
          if (data.settings) setStoreSettings(prev => ({ ...prev, ...data.settings }));
          if (data.soldOutIds !== undefined) setSoldOutIds(normalizeSoldOutIds(data.soldOutIds));
          if (data.menuNames) setMenuNames(data.menuNames);
          if (data.originInfo !== undefined) setOriginInfo(data.originInfo);
          if (data.menuPrices) setMenuPrices(data.menuPrices);
          if (data.customMenus) setCustomMenus(normalizeCustomMenus(data.customMenus));
          if (data.announcement !== undefined) {
            setAnnouncement(String(data.announcement ?? '').slice(0, ANNOUNCEMENT_MAX_LENGTH));
          }
        }
      }, (error) => {
        console.error("Firebase 설정 로드 실패:", error);
      });
    } catch (e) {
      console.error("설정 로드 실패:", e);
    }
  };

  const checkShopStatus = () => {
    if (storeSettings.isTemporaryPaused === true) {
      setShopStatus({ isOpen: false, message: "💼 준비중", subMessage: "매장 준비 중입니다.\n잠시만 기다려주세요." });
      return;
    }
    if (storeSettings.forceOpen === true) {
      setShopStatus({ isOpen: true, message: "" });
      return;
    }

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const [openH, openM] = storeSettings.openTime.split(':').map(Number);
    const [closeH, closeM] = storeSettings.closeTime.split(':').map(Number);
    const openMinutes = openH * 60 + openM;
    const closeMinutes = closeH * 60 + closeM;

    if (currentMinutes < openMinutes || currentMinutes >= closeMinutes) {
      setShopStatus({
        isOpen: false,
        message: "🛑 영업종료",
        subMessage: `운영 시간: ${storeSettings.openTime} ~ ${storeSettings.closeTime}`
      });
      return;
    }

    const [breakStartH, breakStartM] = storeSettings.breakStartTime.split(':').map(Number);
    const [breakEndH, breakEndM] = storeSettings.breakEndTime.split(':').map(Number);
    const breakStartMinutes = breakStartH * 60 + breakStartM;
    const breakEndMinutes = breakEndH * 60 + breakEndM;

    if (currentMinutes >= breakStartMinutes && currentMinutes < breakEndMinutes) {
      setShopStatus({
        isOpen: false,
        message: "🕒 브레이크 타임",
        subMessage: `재정비 시간: ${storeSettings.breakStartTime} ~ ${storeSettings.breakEndTime}`
      });
      return;
    }

    setShopStatus({ isOpen: true, message: "" });
  };

  useEffect(() => {
    fetchOrders();
    fetchStoreSettings();
    return () => {
      ordersRef.off();
      settingsRef.off();
    };
  }, []);

  useEffect(() => {
    checkShopStatus();
    const statusInterval = setInterval(checkShopStatus, 1000);
    return () => clearInterval(statusInterval);
  }, [storeSettings]);

  useEffect(() => {
    if (!selectedMenu) return;
    const menuData = getMenuData();
    const stillExists = Object.values(menuData).flat().some(m => m.id === selectedMenu.id);
    if (!stillExists) {
      setSelectedMenu(null);
    }
  }, [customMenus]);

  const checkDeliveryMinAmount = (newCart) => {
    if (orderType !== 'delivery') return;
    const minAmt = storeSettings.minDeliveryAmount || 0;
    if (minAmt <= 0) return;
    const newTotal = newCart.reduce((s, i) => s + (i.price * i.quantity), 0);
    const prevTotal = cart.reduce((s, i) => s + (i.price * i.quantity), 0);
    if (newTotal >= minAmt && prevTotal < minAmt) {
      setDeliveryToast(`🛵 배달 가능 금액(${minAmt.toLocaleString()}원)에 도달했어요!`);
      setTimeout(() => setDeliveryToast(null), 3500);
    }
  };

  const addToCartWithOption = () => {
    const itemOptions = spicyList.map((s, idx) => {
      const tQ = toppingQtysList[idx];
      const activeToppings = TOPPINGS_DATA.filter(t => tQ[t.id] > 0).map(t => ({ ...t, qty: tQ[t.id] }));
      return { spicy: s, toppings: activeToppings };
    });
    const totalToppingPrice = itemOptions.reduce((acc, opt) =>
      acc + opt.toppings.reduce((tAcc, t) => tAcc + (t.price * t.qty), 0), 0);
    const newCart = [...cart, {
      ...selectedMenu,
      itemOptions,
      quantity: 1,
      price: selectedMenu.price + totalToppingPrice,
      cartId: Date.now()
    }];
    checkDeliveryMinAmount(newCart);
    setCart(newCart);
    setSelectedMenu(null);
    setToppingQtysList([{ t1: 0, t2: 0, t3: 0 }]);
    setSpicyList([""]);
  };

  const addTempToCart = () => {
    const allMenuById = new Map(Object.values(getMenuData()).flat().map(item => [String(item.id), item]));
    const selectedEntries = Object.entries(tempQtys)
      .filter(([, quantity]) => Number(quantity) > 0);
    const missingMenuIds = selectedEntries
      .filter(([id]) => !allMenuById.has(id))
      .map(([id]) => id);
    if (missingMenuIds.length > 0) {
      alert('선택한 메뉴 정보를 찾을 수 없습니다. 메뉴를 새로고침한 뒤 다시 담아주세요.');
      return;
    }
    const newItems = selectedEntries.map(([id, quantity]) => ({
      ...allMenuById.get(id),
      quantity: Number(quantity),
      cartId: `${Date.now()}-${Math.random()}`
    }));
    if (newItems.length > 0) {
      const newCart = [...cart];
      newItems.forEach(newItem => {
        const idx = newCart.findIndex(i => String(i.id) === String(newItem.id) && !i.itemOptions);
        if (idx > -1) newCart[idx] = { ...newCart[idx], quantity: newCart[idx].quantity + newItem.quantity };
        else newCart.push(newItem);
      });
      checkDeliveryMinAmount(newCart);
      setCart(newCart);
    }
    setTempQtys({});
  };

  const addToCartSimple = () => {
    let newCart;
    const existingIdx = cart.findIndex(i => i.id === selectedMenu.id && !i.itemOptions);
    if (existingIdx > -1) {
      newCart = [...cart];
      newCart[existingIdx] = { ...newCart[existingIdx], quantity: newCart[existingIdx].quantity + modalQty };
    } else {
      newCart = [...cart, { ...selectedMenu, quantity: modalQty, cartId: Date.now() }];
    }
    checkDeliveryMinAmount(newCart);
    setCart(newCart);
    setSelectedMenu(null);
    setModalQty(1);
  };

  const saveOrderToCloud = async (newOrder, retryCount = 0) => {
    try {
      let localOrders = [];
      try {
        const stored = localStorage.getItem('orders_backup');
        if (stored) localOrders = JSON.parse(stored);
      } catch (e) {}
      const updatedLocalOrders = [...localOrders, newOrder];
      localStorage.setItem('orders_backup', JSON.stringify(updatedLocalOrders));

      try {
        const snapshot = await ordersRef.once('value');
        const currentOrders = snapshot.val() || [];
        const ordersArray = Array.isArray(currentOrders) ? currentOrders : [];
        const updatedOrders = [...ordersArray, newOrder];
        await ordersRef.set(updatedOrders);
        setOrders(updatedOrders);
        return { success: true };
      } catch (firebaseError) {
        if (retryCount < 2) {
          const waitTime = (retryCount + 1) * 2500 + 500;
          await new Promise(r => setTimeout(r, waitTime));
          return saveOrderToCloud(newOrder, retryCount + 1);
        }
        return { success: false, error: firebaseError.message };
      }
    } catch (e) {
      return { success: false, error: e.message };
    }
  };

  const finalOrder = async (selectedMethod) => {
    if (cart.length === 0) {
      alert('주문할 메뉴가 없습니다.');
      return false;
    }
    const subtotal = cart.reduce((s, i) => s + (i.price * i.quantity), 0);
    let deliveryFee = 0;
    if (orderType === 'delivery' && storeSettings.deliveryFees) {
      const applicableTier = [...storeSettings.deliveryFees]
        .sort((a, b) => b.minAmount - a.minAmount)
        .find(tier => subtotal >= tier.minAmount);
      if (applicableTier) deliveryFee = applicableTier.fee;
    }
    const discount = (storeSettings.discounts && storeSettings.discounts[orderType] && subtotal >= (storeSettings.discounts[orderType].minAmount || 0))
      ? (storeSettings.discounts[orderType].discountValue || 0) : 0;

    const _orderNow = new Date();
    const secureId = crypto.randomUUID().replace(/-/g, '').slice(0, 8).toUpperCase();
    const newOrder = {
      date: _orderNow.toLocaleTimeString(),
      dateStr: _orderNow.toLocaleDateString('ko-KR'),
      orderNo: orders.length + 101,
      secureId: secureId,
      linkExpiry: _orderNow.getTime() + 2 * 60 * 60 * 1000,
      status: 'pending',
      details: cart.map(i => {
        if (i.itemOptions) {
          const optStr = i.itemOptions.map((opt, idx) => {
            const topStr = (opt.toppings && opt.toppings.length > 0) ? `+토핑(${opt.toppings.map(t => t.name).join("/" )})` : "";
            return `맛${idx + 1}:${opt.spicy}${topStr}`;
          }).join(", ");
          return `${i.name}(${optStr}) x${i.quantity}`;
        }
        return `${i.name} x${i.quantity}`;
      }).join(" | "),
      originalTotal: subtotal,
      discount: discount,
      deliveryFee: deliveryFee,
      total: subtotal - discount + deliveryFee,
      orderType: orderType,
      createdBy: authUser ? {
        uid: authUser.uid,
        email: authUser.email || null,
        name: authUser.displayName || null
      } : null,
      userInfo: (orderType === 'takeout-reservation' || orderType === 'delivery') ? {
        phone: userInfo.phone ? userInfo.phone.trim() : '',
        address: (userInfo.address + " " + (userInfo.detailAddress || '')).trim(),
        privacyAgreed: userInfo.privacyAgreed || false
      } : null,
      paymentMethod: selectedMethod || paymentMethod,
      items: JSON.parse(JSON.stringify(cart)),
      disposableUtensils: (orderType === 'takeout' || orderType === 'takeout-reservation' || orderType === 'delivery') ? disposableUtensils : null,
      tteokPackaging: (orderType === 'takeout' || orderType === 'takeout-reservation' || orderType === 'delivery') ? tteokPackaging : null
    };

    const result = await saveOrderToCloud(newOrder);
    if (!result.success) {
      alert('주문 접수에 실패했습니다. 메뉴를 유지했으니 잠시 후 다시 시도해 주세요.\n' + (result.error || ''));
      return false;
    }
    setLastOrderNo(newOrder.orderNo);
    localStorage.setItem('lastOrderNo', newOrder.orderNo);
    setCart([]);
    setIsConfirmOpen(false);
    setOrderType(null);
    return true;
  };

  const copyAccount = async () => {
    let copied = true;
    try {
      await navigator.clipboard.writeText("743-910273-51707");
    } catch (error) {
      copied = false;
      console.error('계좌번호 복사 실패:', error);
      alert('계좌번호 복사에 실패했지만 주문 접수는 계속 진행합니다.');
    }
    const ot = orderType;
    const success = await finalOrder('transfer');
    if (!success) return;
    alert(copied ? "계좌번호가 복사되었습니다. 주문을 접수합니다." : "주문이 접수되었습니다. 계좌번호를 확인해 주세요.");
    setShowPaymentModal(false);
    if (ot === 'takeout-reservation' || ot === 'delivery') {
      setLastOrderType(ot);
      setShowOrderConfirm(true);
    }
  };

  const cardPaymentAlert = async () => {
    const ot = orderType;
    const success = await finalOrder('card');
    if (!success) return;
    setShowPaymentModal(false);
    if (ot === 'takeout-reservation' || ot === 'delivery') {
      setLastOrderType(ot);
      setShowOrderConfirm(true);
    }
  };
  const cashPaymentAlert = async () => {
    const ot = orderType;
    const success = await finalOrder('cash');
    if (!success) return;
    setShowPaymentModal(false);
    if (ot === 'takeout-reservation' || ot === 'delivery') {
      setLastOrderType(ot);
      setShowOrderConfirm(true);
    }
  };
  const closeModal = () => setShowPaymentModal(false);

  return (
    <div>
      {/* 주문조회 모드 (?o=secureId) */}
      {urlOrderId && (() => {
        const found = orders.find(o => o.secureId === urlOrderId);

        // 만료 여부 확인
        const isExpired = found && found.linkExpiry && Date.now() > found.linkExpiry;

        const statusLabel = found && !isExpired ? (
          found.status === 'pending' ? '접수 대기' :
          found.status === 'accepted' ? '조리 중' :
          found.status === 'completed' ? '완료' : '취소됨'
        ) : null;
        const statusColor = found ? (
          found.status === 'pending' ? '#e67e22' :
          found.status === 'accepted' ? '#2980b9' :
          found.status === 'completed' ? '#27ae60' : '#888'
        ) : '#888';
        const typeLabel = found ? (
          found.orderType === 'delivery' ? '배달' :
          found.orderType === 'takeout-reservation' ? '포장예약' :
          found.orderType === 'takeout' ? '매장포장' : '매장식사'
        ) : '';
        const payLabel = found ? (
          found.paymentMethod === 'card' ? '카드 결제' :
          found.paymentMethod === 'transfer' ? '계좌이체' : '현금 결제'
        ) : '';

        return (
          <div style={{position: 'fixed', inset: 0, background: 'white', zIndex: 9000, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px', boxSizing: 'border-box'}}>
            <div style={{ width: '100%', maxWidth: '420px' }}>
              <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <div style={{ fontSize: '1.4rem', fontWeight: 'bold', color: '#ed1c24' }}>신전떡볶이 홍성점</div>
                <div style={{ fontSize: '0.95rem', color: '#888', marginTop: '4px' }}>주문 조회</div>
              </div>

              {isExpired ? (
                <div style={{ border: '2px solid #eee', borderRadius: '18px', padding: '32px 24px', textAlign: 'center' }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '16px' }}>⏰</div>
                  <div style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#333', marginBottom: '8px' }}>유효기간이 만료된 링크입니다</div>
                  <div style={{ fontSize: '0.85rem', color: '#888', marginBottom: '24px' }}>주문 조회 링크는 접수 후 2시간 동안만 유효합니다.</div>
                  <button onClick={() => { try { window.close(); } catch(e) {} window.location.href = 'about:blank'; }} style={{ padding: '13px 36px', background: '#333', color: 'white', border: 'none', borderRadius: '12px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer' }}>닫기</button>
                </div>
              ) : found ? (
                <div style={{ border: '2px solid #eee', borderRadius: '18px', padding: '20px', background: '#fff' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <span style={{ fontSize: '1.4rem', fontWeight: 'bold', color: '#333' }}>#{found.orderNo}</span>
                    <span style={{ fontSize: '0.95rem', fontWeight: 'bold', color: statusColor, background: statusColor + '18', padding: '4px 12px', borderRadius: '20px' }}>{statusLabel}</span>
                  </div>
                  <div style={{ fontSize: '0.8rem', color: '#888', marginBottom: '12px' }}>{typeLabel} · {found.date} · {found.dateStr}</div>

                  <div style={{ borderTop: '1px solid #eee', paddingTop: '10px', marginBottom: '10px' }}>
                    {found.items ? found.items.map((item, idx) => (
                      <div key={idx} style={{ marginBottom: '7px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '0.9rem' }}>
                          <span>{item.name} x{item.quantity}</span>
                          <span>{(item.price * item.quantity).toLocaleString()}원</span>
                        </div>
                        {item.itemOptions && item.itemOptions.map((opt, oi) => (
                          <div key={oi} style={{ fontSize: '0.78rem', color: '#ed1c24', paddingLeft: '8px' }}>└ {opt.spicy}{opt.toppings && opt.toppings.length > 0 ? ' / ' + opt.toppings.map(t => t.name).join(', ') : ''}</div>
                        ))}
                      </div>
                    )) : (
                      <div style={{ color: '#555', fontSize: '0.88rem' }}>{found.details}</div>
                    )}
                  </div>

                  <div style={{ borderTop: '1px solid #eee', paddingTop: '10px', fontSize: '0.85rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                      <span style={{ color: '#888' }}>결제 방법</span>
                      <span style={{ fontWeight: 'bold' }}>{payLabel}</span>
                    </div>
                    {found.discount > 0 && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span style={{ color: '#888' }}>할인</span>
                        <span style={{ color: '#ed1c24', fontWeight: 'bold' }}>-{found.discount.toLocaleString()}원</span>
                      </div>
                    )}
                    {found.deliveryFee > 0 && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span style={{ color: '#888' }}>배달팁</span>
                        <span style={{ fontWeight: 'bold' }}>+{found.deliveryFee.toLocaleString()}원</span>
                      </div>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '1.1rem', color: '#ed1c24', marginTop: '6px', borderTop: '1px solid #eee', paddingTop: '8px' }}>
                      <span>합계</span><span>{found.total.toLocaleString()}원</span>
                    </div>
                  </div>

                  {found.userInfo && found.userInfo.address && (
                    <div style={{ marginTop: '10px', background: '#f9f9f9', borderRadius: '8px', padding: '8px 10px', fontSize: '0.82rem', color: '#555' }}>배달지: {found.userInfo.address}</div>
                  )}
                </div>
              ) : orders.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#aaa' }}>
                  <div style={{ marginBottom: '12px', fontSize: '1rem' }}>주문 정보를 불러오는 중...</div>
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '40px', color: '#aaa' }}>
                  <div>주문을 찾을 수 없습니다.</div>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {!shopStatus.isOpen ? (
        <div className="gate-container" style={{ background: 'rgba(0, 0, 0, 0.5)' }}>
          <div style={{ textAlign: 'center', padding: '30px 25px', background: 'rgba(255, 255, 255, 0.92)', borderRadius: '16px', boxShadow: '0 15px 50px rgba(0, 0, 0, 0.3)', maxWidth: '320px', margin: '0 auto' }}>
            <div style={{ fontSize: '1.4rem', fontWeight: 'bold', color: '#333', marginBottom: '8px', lineHeight: '1.5' }}>{shopStatus.message}</div>
            {shopStatus.subMessage && (
              <div style={{ fontSize: '0.9rem', color: '#666', whiteSpace: 'pre-line', lineHeight: '1.6' }}>{shopStatus.subMessage}</div>
            )}
          </div>
        </div>
      ) : !orderType ? (
        <div className="gate-container">
          <div style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '10px', color: '#ed1c24', lineHeight: '1.1', textAlign: 'center' }}>신전떡볶이<br/>홍성점</div>
          <div className="gate-title" style={{ marginBottom: '15px', fontSize: '1.1rem' }}>원하는 버튼을 선택하세요</div>
          <div className="gate-options" style={{ gap: '10px' }}>
            {[
              { key: 'dine-in',  icon: '🍴', label: '매장 식사', onClick: () => setOrderType('dine-in') },
              { key: 'takeout',  icon: '🛍️', label: '포장',      onClick: () => setShowTakeoutConfirm(true) },
              { key: 'delivery', icon: '🛵', label: '배달주문',  onClick: () => { setUserInfo({ phone: '', address: '', detailAddress: '', privacyAgreed: false }); setPendingOrderType('delivery'); } },
              { key: 'announcement', icon: '🔔', label: '알림', onClick: () => setShowAnnouncementModal(true) }
            ].map(({ key, icon, label, onClick }) => {
              const isAnnouncement = key === 'announcement';
              const disc = storeSettings.discounts?.[key];
              const hasDiscount = disc && disc.discountValue > 0;
              const deliveryFees = key === 'delivery' && storeSettings.deliveryFees && storeSettings.deliveryFees.length > 0
                ? [...storeSettings.deliveryFees].sort((a, b) => a.minAmount - b.minAmount) : null;
              const baseFee = deliveryFees ? deliveryFees[0] : null;
              const freeTier = deliveryFees ? deliveryFees.find(t => t.fee === 0) : null;
              const minDelivery = key === 'delivery' && (storeSettings.minDeliveryAmount || 0) > 0;
              return (
                <button key={key} className={`gate-option-btn`} onClick={onClick} disabled={isAnnouncement && !announcement} style={{ position: 'relative', overflow: 'hidden', opacity: (isAnnouncement && !announcement) ? 0.4 : 1, cursor: (isAnnouncement && !announcement) ? 'not-allowed' : 'pointer', filter: (isAnnouncement && !announcement) ? 'grayscale(0.5)' : 'none' }}>
                  {hasDiscount && (
                    <div style={{ position: 'absolute', top: '8px', right: '8px', background: 'var(--main-red)', color: 'white', fontSize: '0.72rem', fontWeight: 'bold', padding: '3px 7px', borderRadius: '10px', lineHeight: '1.4', whiteSpace: 'nowrap' }}>-{disc.discountValue.toLocaleString()}원</div>
                  )}
                  <div className="gate-icon">{icon}</div>
                  <div className="gate-label">{label}</div>
                  {isAnnouncement && announcement && (
                    <div style={{ fontSize: '0.7rem', color: '#ed1c24', fontWeight: 'bold', marginTop: '3px' }}>공지사항 있음</div>
                  )}
                  {!isAnnouncement && (
                    <div style={{ fontSize: '0.74rem', fontWeight: 'bold', whiteSpace: 'nowrap', marginTop: '3px', color: hasDiscount ? 'var(--main-red)' : 'transparent', minHeight: '1em' }}>
                      {hasDiscount ? (disc.minAmount > 0 ? `${disc.minAmount.toLocaleString()}원↑ ${disc.discountValue.toLocaleString()}원할인` : `${disc.discountValue.toLocaleString()}원 할인`) : '　'}
                    </div>
                  )}
                  {key === 'delivery' && deliveryFees && (
                    <div style={{ fontSize: '0.7rem', color: '#888', whiteSpace: 'nowrap', lineHeight: '1.6', textAlign: 'center' }}>
                      {baseFee && baseFee.fee > 0 ? `배달팁 ${baseFee.fee.toLocaleString()}원~` : '배달팁 무료'}
                      {freeTier && freeTier.minAmount > 0 && (
                        <span style={{ display: 'block', color: '#2e7d32', fontSize: '0.68rem', whiteSpace: 'nowrap' }}>{freeTier.minAmount.toLocaleString()}원↑ 무료</span>
                      )}
                    </div>
                  )}
                  {minDelivery && (
                    <div style={{ fontSize: '0.68rem', color: '#aaa', marginTop: '1px', whiteSpace: 'nowrap' }}>최소 {storeSettings.minDeliveryAmount.toLocaleString()}원</div>
                  )}
                </button>
              );
            })}
          </div>

          <a href="tel:041-633-0092" className="gate-call-btn" style={{ padding: '12px', fontSize: '1rem', marginTop: '5px' }}>📞 매장 전화 연결 (041-633-0092)</a>
          <div style={{ marginTop: '14px', padding: '10px 18px', background: 'linear-gradient(135deg, #fff5f5, #fff)', border: '1.5px solid #fddcdc', borderRadius: '20px', textAlign: 'center', fontSize: '0.82rem', color: '#c0392b', fontWeight: 'bold', letterSpacing: '0.02em', lineHeight: '1.6' }}>🏷️ 매장가격 그대로 · 앱 설치 및 회원가입 없음</div>

          {/* 포장 방식 선택 모달 (매장포장 vs 포장예약) */}
          {showTakeoutConfirm && (
            <div className="modal-overlay" style={{ zIndex: 5000 }}>
              <div className="modal-content" style={{ maxWidth: '360px', textAlign: 'center' }}>
                <div style={{ fontSize: '2.2rem', marginBottom: '8px' }}>🛍️</div>
                <h3 style={{ color: 'var(--main-red)', marginBottom: '6px' }}>포장 방식 선택</h3>
                <p style={{ color: '#666', fontSize: '0.88rem', marginBottom: '20px', lineHeight: '1.5' }}>
                  지금 매장에 계신가요, 아니면 미리 예약하시겠어요?
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {/* 매장포장 */}
                  <button
                    onClick={() => { setShowTakeoutConfirm(false); setOrderType('takeout'); }}
                    style={{
                      padding: '16px', background: '#fff0f0', border: '2px solid var(--main-red)',
                      borderRadius: '14px', cursor: 'pointer', textAlign: 'left'
                    }}>
                    <div style={{ fontWeight: 'bold', fontSize: '1rem', color: 'var(--main-red)', marginBottom: '3px' }}>
                      🏪 매장에서 바로 포장
                    </div>
                    <div style={{ fontSize: '0.8rem', color: '#888' }}>지금 매장에 계신 분 · 즉석 주문</div>
                  </button>
                  {/* 포장예약 */}
                  <button
                    onClick={() => {
                      setShowTakeoutConfirm(false);
                      setUserInfo({ phone: '', address: '', detailAddress: '', privacyAgreed: false });
                      setPendingOrderType('takeout-reservation');
                    }}
                    style={{
                      padding: '16px', background: '#f0f4ff', border: '2px solid #4a7aff',
                      borderRadius: '14px', cursor: 'pointer', textAlign: 'left'
                    }}>
                    <div style={{ fontWeight: 'bold', fontSize: '1rem', color: '#4a7aff', marginBottom: '3px' }}>
                      📞 미리 예약 포장
                    </div>
                    <div style={{ fontSize: '0.8rem', color: '#888' }}>외부에서 미리 주문 · 방문 수령</div>
                  </button>
                  {/* 취소 */}
                  <button
                    onClick={() => setShowTakeoutConfirm(false)}
                    style={{ padding: '10px', background: 'none', border: 'none', color: '#aaa', fontSize: '0.9rem', cursor: 'pointer' }}>
                    취소
                  </button>
                </div>
              </div>
            </div>
          )}

          {pendingOrderType && (
            <div className="modal-overlay" style={{ zIndex: 5000 }}>
              <div className="modal-content" style={{ maxWidth: '400px' }}>
                <h3 style={{ textAlign: 'center', color: 'var(--main-red)' }}>
                  {pendingOrderType === 'delivery' ? '🛵 배달 정보 입력' : '📞 예약 정보 입력'}
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', margin: '20px 0' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '0.9rem', marginBottom: '5px', fontWeight: 'bold' }}>전화번호</label>
                    <input
                      type="tel"
                      placeholder="010-0000-0000"
                      value={userInfo.phone}
                      onChange={(e) => {
                        const digits = e.target.value.replace(/\D/g, '').slice(0, 11);
                        let formatted = digits;
                        if (digits.length >= 4 && digits.length <= 7) formatted = digits.slice(0,3) + '-' + digits.slice(3);
                        else if (digits.length >= 8 && digits.startsWith('02')) formatted = digits.slice(0,2) + '-' + digits.slice(2,6) + '-' + digits.slice(6);
                        else if (digits.length >= 8) formatted = digits.slice(0,3) + '-' + digits.slice(3,7) + '-' + digits.slice(7);
                        setUserInfo(prev => ({ ...prev, phone: formatted }));
                      }}
                      style={{
                        width: '100%', padding: '12px', borderRadius: '8px', boxSizing: 'border-box',
                        border: userInfo.phone && !/^(01[016789]-\d{3,4}-\d{4}|0\d{1,2}-\d{3,4}-\d{4})$/.test(userInfo.phone)
                          ? '2px solid #e74c3c' : '1px solid #ddd'
                      }}
                    />
                    {userInfo.phone && !/^(01[016789]-\d{3,4}-\d{4}|0\d{1,2}-\d{3,4}-\d{4})$/.test(userInfo.phone) && (
                      <div style={{ color: '#e74c3c', fontSize: '0.78rem', marginTop: '4px' }}>올바른 전화번호를 입력해 주세요 (예: 010-1234-5678)</div>
                    )}
                  </div>
                  {pendingOrderType === 'delivery' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <label style={{ display: 'block', fontSize: '0.9rem', marginBottom: '0', fontWeight: 'bold' }}>배달 주소</label>
                      <div style={{ display: 'flex', gap: '5px' }}>
                        <input
                          type="text"
                          placeholder="주소 검색을 클릭하세요"
                          value={userInfo.address}
                          readOnly
                          onClick={handleAddressSearch}
                          style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box', background: '#f9f9f9', cursor: 'pointer' }}
                        />
                        <button
                          type="button"
                          onClick={handleAddressSearch}
                          style={{ padding: '0 15px', borderRadius: '8px', border: 'none', background: '#333', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}
                        >
                          검색
                        </button>
                      </div>
                      <input
                        type="text"
                        placeholder="상세 주소를 입력해주세요"
                        value={userInfo.detailAddress}
                        onChange={(e) => setUserInfo(prev => ({ ...prev, detailAddress: e.target.value }))}
                        style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box' }}
                      />
                    </div>
                  )}
                  <div style={{ background: '#f5f5f5', padding: '10px', borderRadius: '8px', fontSize: '0.8rem', color: '#666' }}>
                    <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        checked={userInfo.privacyAgreed}
                        onChange={(e) => setUserInfo(prev => ({ ...prev, privacyAgreed: e.target.checked }))}
                        style={{ marginTop: '3px' }}
                      />
                      <span>[필수] 개인정보 수집 및 이용 동의<br />(주문 확인{pendingOrderType === 'delivery' ? ' 및 배달' : ''}을 위해 전화번호{pendingOrderType === 'delivery' ? '와 주소' : ''}가 사용됩니다.)</span>
                    </label>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button className="btn-sub" onClick={() => { setPendingOrderType(null); setUserInfo({ phone: '', address: '', privacyAgreed: false }); }}>취소</button>
                  <button
                    className="btn-main"
                    disabled={!userInfo.phone || !/^(01[016789]-\d{3,4}-\d{4}|0\d{1,2}-\d{3,4}-\d{4})$/.test(userInfo.phone) || (pendingOrderType === 'delivery' && (!userInfo.address || !userInfo.detailAddress)) || !userInfo.privacyAgreed}
                    onClick={() => { setOrderType(pendingOrderType); setPendingOrderType(null); }}
                    style={{ opacity: (!userInfo.phone || !/^(01[016789]-\d{3,4}-\d{4}|0\d{1,2}-\d{3,4}-\d{4})$/.test(userInfo.phone) || (pendingOrderType === 'delivery' && (!userInfo.address || !userInfo.detailAddress)) || !userInfo.privacyAgreed) ? 0.5 : 1 }}
                  >
                    선택 완료
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <>
          <header className="header">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', position: 'relative' }}>
              <span style={{ fontSize: '0.8rem', background: 'rgba(255,255,255,0.2)', padding: '2px 8px', borderRadius: '4px' }}>{orderType === 'takeout' ? '🛍️ 매장포장' : (orderType === 'takeout-reservation' ? '📞 포장예약' : (orderType === 'dine-in' ? '🍴 매장' : '🛵 배달'))}</span>
              <strong>신전떡볶이 홍성점</strong>
              <button onClick={() => { setOrderType(null); setLastOrderNo(null); localStorage.removeItem('lastOrderNo'); }} style={{ marginLeft: '10px', background: 'none', border: '1px solid rgba(255,255,255,0.5)', color: 'white', fontSize: '0.7rem', padding: '2px 5px', borderRadius: '3px', cursor: 'pointer' }}>돌아가기</button>
            </div>
            <div style={{ marginTop: '6px', textAlign: 'center' }}>
              <button onClick={() => setShowOriginModal(true)} style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.4)', color: 'white', fontSize: '0.72rem', padding: '3px 10px', borderRadius: '4px', cursor: 'pointer' }}>📋 원산지 표시</button>
            </div>
          </header>

          <nav className="nav-tabs">
            {Object.keys(currentMenuData).map(cat => (
              <button key={cat} className={`tab ${currentCat === cat ? 'active' : ''}`} onClick={() => setCurrentCat(cat)}>{cat}</button>
            ))}
          </nav>

          <main style={{ paddingBottom: '100px' }}>
            {(currentMenuData[currentCat] || []).map(item => {
              const SET_COMPONENTS = { 15: [10,11,12,13], 30: [15,10,11,12,13,41], 31: [10,11,12,13,19,41], 32: [10,11,12,41], 33: [10,11,13,41], 34: [10,11,12,13,19,41] };
              const CHEESE_LINKED = { 2: 't1', 25: 't1' };
              const SAUCE_MENUS = { 's1': [1,2], 's2': [1,2], 's3': [1,2], 's4': [3] };
              const directSoldOut = soldOutIds.includes(item.id);
              const componentSoldOut = SET_COMPONENTS[item.id] ? SET_COMPONENTS[item.id].some(cid => soldOutIds.includes(cid)) : false;
              const linkedSoldOut = CHEESE_LINKED[item.id] ? soldOutIds.includes(CHEESE_LINKED[item.id]) : false;
              const sauceSoldOut = !item.hasOptions && Object.entries(SAUCE_MENUS).some(([sauceId, menuIds]) => soldOutIds.includes(sauceId) && menuIds.includes(item.id));
              const isSoldOut = directSoldOut || componentSoldOut || linkedSoldOut || sauceSoldOut;
              const soldOutReason = componentSoldOut ? '구성품 품절' : linkedSoldOut ? '재료 품절' : sauceSoldOut ? '소스 품절' : '';

              return (
                <div key={item.id} className="menu-item" style={{ opacity: isSoldOut ? 0.5 : 1, pointerEvents: isSoldOut ? 'none' : 'auto' }}>
                  <div className="menu-content">
                    <div className="menu-thumb" style={{ background: '#f9f9f9', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0, position: 'relative' }}>
                      {item.image ? <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover', filter: isSoldOut ? 'grayscale(100%)' : 'none' }} /> : <div style={{ fontSize: '10px', color: '#ccc' }}>IMAGE</div>}
                      {isSoldOut && <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)', color: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '0.8rem' }}><span>품절</span>{soldOutReason && <span style={{ fontSize: '0.65rem', marginTop: '2px', opacity: 0.85 }}>{soldOutReason}</span>}</div>}
                    </div>
                    <div style={{ flex: 1, minWidth: 0, paddingRight: '10px' }}>
                      {(() => { const displayName = menuNames[item.id] || item.name; const displayPrice = menuPrices[item.id] !== undefined ? menuPrices[item.id] : item.price; const parts = displayName.split('('); return (<div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}><div style={{ fontSize: '1.05rem', fontWeight: 'bold', lineHeight: '1.3', wordBreak: 'keep-all' }}>{parts[0]}</div>{parts[1] && <div style={{ fontSize: '0.85rem', color: '#666', lineHeight: '1.4' }}>({parts[1]}</div>}<div style={{ marginTop: '6px', fontWeight: 'bold', color: 'var(--main-red)', fontSize: '1.1rem' }}>{isSoldOut ? 'SOLD OUT' : `${displayPrice.toLocaleString()}원`}</div></div>); })()}
                    </div>
                  </div>

                  {item.hasOptions ? (
                    <button disabled={isSoldOut} onClick={() => { const count = item.tteokCount || 1; setSpicyList(Array(count).fill("") ); setToppingQtysList(Array(count).fill(null).map(() => ({ t1:0,t2:0,t3:0 }))); setSelectedMenu(item); }} style={{ border: isSoldOut ? '1.5px solid #ccc' : '1.5px solid #ed1c24', color: isSoldOut ? '#ccc' : '#ed1c24', background: 'none', padding: '8px 18px', borderRadius: '20px', fontWeight: 'bold', flexShrink: 0 }}>{isSoldOut ? '품절' : '선택'}</button>
                  ) : (
                    <div className="qty-control" style={{ flexShrink: 0, opacity: isSoldOut ? 0 : 1 }}>
                      <button className="qty-btn" onClick={() => setTempQtys(prev => ({ ...prev, [String(item.id)]: Math.max(0, (prev[String(item.id)] || 0) - 1) }))}>-</button>
                      <span className="qty-num" style={{ minWidth: '20px', textAlign: 'center' }}>{tempQtys[String(item.id)] || 0}</span>
                      <button className="qty-btn plus" onClick={() => setTempQtys(prev => ({ ...prev, [String(item.id)]: (prev[String(item.id)] || 0) + 1 }))}>+</button>
                    </div>
                  )}
                </div>
              );
            })}

            {Object.values(tempQtys).some(q => q > 0) && (
              <div style={{ position: 'fixed', bottom: '80px', left: '50%', transform: 'translateX(-50%)', width: 'calc(100% - 20px)', maxWidth: '480px', background: '#fff', padding: '12px', borderRadius: '15px', border: '2px solid var(--main-red)', boxShadow: '0 -4px 20px rgba(0,0,0,0.15)', display: 'flex', gap: '10px', zIndex: 1000, boxSizing: 'border-box' }}>
                <button onClick={() => setTempQtys({})} style={{ flex: 1, padding: '15px', borderRadius: '10px', background: '#eee', border: 'none', color: '#666', fontWeight: 'bold', fontSize: '1rem' }}>취소</button>
                <button onClick={addTempToCart} style={{ flex: 2, padding: '15px', borderRadius: '10px', background: 'var(--main-red)', color: '#fff', border: 'none', fontWeight: 'bold', fontSize: '1rem' }}>장바구니 담기</button>
              </div>
            )}
          </main>
          {/* 옵션 모달 */}
          {selectedMenu && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h3 style={{ marginTop: 0 }}>{selectedMenu.name}</h3>
                {selectedMenu.hasOptions ? (
                  <div>
                    {spicyList.map((s, idx) => (
                      <div key={idx} style={{ marginBottom: '25px', padding: '15px', background: '#f9f9f9', borderRadius: '12px' }}>
                        <span style={{ fontWeight: 'bold', color: 'var(--main-red)' }}>{spicyList.length > 1 ? `구성 ${idx + 1}` : '메뉴 구성'}</span>
                        <div style={{ marginTop: '10px' }}>
                          <span style={{ fontSize: '0.9rem', color: '#666' }}>맛 선택</span>
                          <div className="spicy-row" style={{ margin: '8px 0 15px 0' }}>
                            {["순한맛", "중간맛", "매운맛"].map(m => (
                              <div
                                key={m}
                                className={`spicy-btn ${s === m ? 'active' : ''}`}
                                onClick={() => {
                                  const newList = [...spicyList];
                                  newList[idx] = m;
                                  setSpicyList(newList);
                                }}
                              >
                                {m}
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="opt-group" style={{ borderTop: '1px dashed #ddd', paddingTop: '10px' }}>
                          <span style={{ fontSize: '0.9rem', color: '#666' }}>토핑 추가</span>
                          {TOPPINGS_DATA.map(t => {
                            const tSoldOut = soldOutIds.includes(t.id);
                            const tDisplayName  = menuNames[t.id]  || t.name;
                            const tDisplayPrice = menuPrices[t.id] !== undefined ? menuPrices[t.id] : t.price;
                            return (
                              <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', opacity: tSoldOut ? 0.45 : 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                  <div style={{ width: '40px', height: '40px', borderRadius: '6px', overflow: 'hidden', background: '#f5f5f5' }}>
                                    <img src={t.image} alt={tDisplayName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                  </div>
                                  <div>
                                    <div style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>{tDisplayName}{tSoldOut && <span style={{ marginLeft: '6px', fontSize: '0.72rem', color: '#888', background: '#eee', padding: '1px 6px', borderRadius: '4px' }}>품절</span>}</div>
                                    <div style={{ fontSize: '0.75rem', color: 'var(--main-red)' }}>+{tDisplayPrice.toLocaleString()}원</div>
                                  </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <button className="qty-btn" style={{ width: '28px', height: '28px' }} disabled={tSoldOut} onClick={() => {
                                    const newList = [...toppingQtysList];
                                    newList[idx] = { ...newList[idx], [t.id]: Math.max(0, newList[idx][t.id] - 1) };
                                    setToppingQtysList(newList);
                                  }}>-</button>
                                  <span style={{ fontWeight: 'bold', fontSize: '1rem', minWidth: '15px', textAlign: 'center' }}>{toppingQtysList[idx][t.id]}</span>
                                  <button className="qty-btn plus" style={{ width: '28px', height: '28px' }} disabled={tSoldOut} onClick={() => {
                                    if (tSoldOut) return;
                                    const newList = [...toppingQtysList];
                                    newList[idx] = { ...newList[idx], [t.id]: Math.min(2, newList[idx][t.id] + 1) };
                                    setToppingQtysList(newList);
                                  }}>+</button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{ padding: '20px 0', textAlign: 'center' }}>
                    <div style={{ color: '#666', marginBottom: '15px' }}>수량 선택</div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
                      <button className="qty-btn" style={{ width: '40px', height: '40px', fontSize: '20px' }} onClick={() => setModalQty(Math.max(1, modalQty - 1))}>-</button>
                      <span style={{ fontSize: '24px', fontWeight: 'bold' }}>{modalQty}</span>
                      <button className="qty-btn plus" style={{ width: '40px', height: '40px', fontSize: '20px' }} onClick={() => setModalQty(modalQty + 1)}>+</button>
                    </div>
                  </div>
                )}
                <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                  <button className="btn-sub" onClick={() => setSelectedMenu(null)}>취소</button>
                  <button
                    className="btn-main"
                    onClick={selectedMenu.hasOptions ? addToCartWithOption : addToCartSimple}
                    disabled={selectedMenu.hasOptions && spicyList.some(s => !s)}
                    style={{ opacity: (selectedMenu.hasOptions && spicyList.some(s => !s)) ? 0.45 : 1 }}
                  >
                    {selectedMenu.hasOptions && spicyList.some(s => !s) ? '맛을 선택해 주세요' : '장바구니 담기'}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* 최종 주문 확인 */}
          {isConfirmOpen && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2 style={{ textAlign: 'center' }}>최종 주문 확인</h2>
                {/* 포장/배달 시 추가 옵션 */}
                {(orderType === 'takeout' || orderType === 'takeout-reservation' || orderType === 'delivery') && (
                  <div style={{ background: '#fff9f9', border: '1.5px solid #fdd', borderRadius: '12px', padding: '15px', marginBottom: '10px' }}>
                    {/* 일회용 수저 */}
                    <div style={{ marginBottom: '14px' }}>
                      <div style={{ fontWeight: 'bold', fontSize: '0.95rem', marginBottom: '8px', color: '#333' }}>🥢 일회용 수저 필요 여부</div>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        {[{ val: true, label: '✅ 필요해요' }, { val: false, label: '❌ 필요없어요' }].map(opt => (
                          <button
                            key={String(opt.val)}
                            onClick={() => setDisposableUtensils(opt.val)}
                            style={{
                              flex: 1, padding: '10px', borderRadius: '10px', fontWeight: 'bold', fontSize: '0.9rem', cursor: 'pointer',
                              border: disposableUtensils === opt.val ? '2px solid var(--main-red)' : '2px solid #eee',
                              background: disposableUtensils === opt.val ? '#fff0f0' : 'white',
                              color: disposableUtensils === opt.val ? 'var(--main-red)' : '#666'
                            }}
                          >{opt.label}</button>
                        ))}
                      </div>
                    </div>

                    {/* 떡볶이 포장 형태 - 떡볶이 메뉴가 장바구니에 있을 때만 표시 */}
                    {cart.some(i => i.hasOptions) && (() => {
                      const tteokItems = cart.filter(i => i.hasOptions && i.itemOptions);
                      const allOpts = tteokItems.flatMap(item => item.itemOptions ? item.itemOptions : []);
                      const totalTteokCount = tteokItems.reduce((s, item) => s + (item.itemOptions ? item.itemOptions.length : 0), 0);
                      const allSameSpicy = allOpts.length > 1 && allOpts.every(o => o.spicy === allOpts[0].spicy);
                      const toStr = o => (o.toppings || []).map(t => `${t.name}:${t.qty}`).sort().join(',');
                      const allSameTopping = allOpts.length > 1 && allOpts.every(o => toStr(o) === toStr(allOpts[0]));
                      const canTogether = totalTteokCount >= 2 && allSameSpicy && allSameTopping;
                      return (
                        <div>
                          <div style={{ fontWeight: 'bold', fontSize: '0.95rem', marginBottom: '4px', color: '#333' }}>🍱 떡볶이 포장 형태</div>
                          {!canTogether && (
                            <div style={{ fontSize: '0.75rem', color: '#e67e22', marginBottom: '6px' }}>
                              ※ 2인용기 포장은 같은 맛·토핑 2인분 이상일 때 선택 가능합니다
                            </div>
                          )}
                          <div style={{ display: 'flex', gap: '8px' }}>
                            {[{ val: 'separate', label: '1인용기 각각포장' }, { val: 'together', label: '2인용기 포장' }].map(opt => {
                              const disabled = opt.val === 'together' && !canTogether;
                              return (
                                <button
                                  key={opt.val}
                                  onClick={() => { if (!disabled) { setTteokPackaging(opt.val); } }}
                                  style={{
                                    flex: 1, padding: '10px', borderRadius: '10px', fontWeight: 'bold', fontSize: '0.9rem',
                                    cursor: disabled ? 'not-allowed' : 'pointer',
                                    border: tteokPackaging === opt.val && !disabled ? '2px solid var(--main-red)' : '2px solid #eee',
                                    background: disabled ? '#f5f5f5' : (tteokPackaging === opt.val ? '#fff0f0' : 'white'),
                                    color: disabled ? '#ccc' : (tteokPackaging === opt.val ? 'var(--main-red)' : '#666'),
                                    opacity: disabled ? 0.6 : 1
                                  }}
                                >{opt.label}{disabled ? '\n(선택불가)' : ''}</button>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
                <div style={{ margin: '20px 0', borderTop: '2px solid #333', padding: '10px 0' }}>
                  {cart.map((item, idx) => (
                    <div key={idx} style={{ padding: '15px 0', borderBottom: '1px solid #eee', position: 'relative' }}>
                      <button
                        onClick={() => {
                          const newCart = [...cart];
                          newCart.splice(idx, 1);
                          setCart(newCart);
                          if (newCart.length === 0) setIsConfirmOpen(false);
                        }}
                        style={{ position: 'absolute', right: 0, top: 15, background: 'none', border: 'none', color: '#999', fontSize: '1.2rem', cursor: 'pointer', padding: '0 5px' }}
                      >✕</button>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', paddingRight: '25px' }}>
                        <span>{item.name} x{item.quantity}</span>
                        <span>{(item.price * item.quantity).toLocaleString()}원</span>
                      </div>
                      {item.itemOptions && item.itemOptions.map((opt, oIdx) => (
                        <div key={oIdx} style={{ fontSize: '0.85rem', marginTop: '5px', paddingLeft: '10px' }}>
                          <div style={{ color: 'var(--main-red)' }}>└ 선택 {oIdx + 1}: {opt.spicy}</div>
                          {opt.toppings && opt.toppings.map((t, tIdx) => (
                            <div key={tIdx} style={{ color: '#666', marginLeft: '10px' }}>- {t.name} {t.qty}개</div>
                          ))}
                        </div>
                      ))}
                    </div>
                  ))}
                  <div style={{ textAlign: 'right', marginTop: '15px' }}>
                    {(() => {
                      const subtotal = cart.reduce((s, i) => s + (i.price * i.quantity), 0);
                      let deliveryFee = 0;
                      if (orderType === 'delivery' && storeSettings.deliveryFees) {
                        const applicableTier = [...storeSettings.deliveryFees]
                          .sort((a, b) => b.minAmount - a.minAmount)
                          .find(tier => subtotal >= tier.minAmount);
                        if (applicableTier) deliveryFee = applicableTier.fee;
                      }
                      const discount = (storeSettings.discounts && storeSettings.discounts[orderType] && subtotal >= (storeSettings.discounts[orderType].minAmount || 0))
                        ? (storeSettings.discounts[orderType].discountValue || 0) : 0;
                      return (
                        <>
                          <div style={{ fontSize: '1rem', color: '#666', marginBottom: '5px' }}>주문금액: {subtotal.toLocaleString()}원</div>
                          {discount > 0 && <div style={{ fontSize: '1rem', color: '#ed1824', marginBottom: '5px' }}>주문할인: -{discount.toLocaleString()}원</div>}
                          {orderType === 'delivery' && <div style={{ fontSize: '1rem', color: '#333', marginBottom: '5px' }}>배달팁: +{deliveryFee.toLocaleString()}원</div>}
                          <div style={{ fontSize: '1.4rem', fontWeight: 'bold', color: 'var(--main-red)', marginTop: '10px' }}>최종 결제액: {(subtotal - discount + deliveryFee).toLocaleString()}원</div>
                        </>
                      );
                    })()}
                  </div>
                </div>
                <button className="btn-main" onClick={() => { setIsConfirmOpen(false); setShowPaymentModal(true); }}>지금 주문하기</button>
                <button className="btn-sub" onClick={() => setIsConfirmOpen(false)}>추가하기</button>
              </div>
            </div>
          )}

          {cart.length > 0 && !isConfirmOpen && (
            <div className="cart-bar">
              {/* 배달 최소금액 진행 바 */}
              {orderType === 'delivery' && (storeSettings.minDeliveryAmount || 0) > 0 && (() => {
                const minAmt = storeSettings.minDeliveryAmount;
                const currentTotal = cart.reduce((s, i) => s + (i.price * i.quantity), 0);
                const remaining = minAmt - currentTotal;
                const pct = Math.min(100, Math.round((currentTotal / minAmt) * 100));
                const isReached = currentTotal >= minAmt;
                return (
                  <div style={{ marginBottom: '8px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.78rem', marginBottom: '4px' }}>
                      <span style={{ fontWeight: 'bold', color: isReached ? '#2e7d32' : '#c00' }}>
                        {isReached ? '✅ 배달 가능!' : `🛵 ${remaining.toLocaleString()}원 더 담으면 배달 가능`}
                      </span>
                      <span style={{ color: '#888' }}>{currentTotal.toLocaleString()} / {minAmt.toLocaleString()}원</span>
                    </div>
                    <div style={{ height: '6px', background: '#eee', borderRadius: '4px', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: `${pct}%`, background: isReached ? '#4caf50' : '#ed1c24', borderRadius: '4px', transition: 'width 0.3s ease' }} />
                    </div>
                  </div>
                );
              })()}
              <button
                className="btn-main"
                onClick={() => {
                  const minAmt = storeSettings.minDeliveryAmount || 0;
                  if (orderType === 'delivery' && minAmt > 0) {
                    const total = cart.reduce((s, i) => s + (i.price * i.quantity), 0);
                    if (total < minAmt) {
                      alert(`최소 배달 금액은 ${minAmt.toLocaleString()}원입니다.\n현재 ${total.toLocaleString()}원 (${(minAmt - total).toLocaleString()}원 부족)`);
                      return;
                    }
                  }
                  setIsConfirmOpen(true);
                }}
              >
                주문하기 ({cart.reduce((s, i) => s + i.quantity, 0)}개 / {cart.reduce((s, i) => s + (i.price * i.quantity), 0).toLocaleString()}원)
              </button>
            </div>
          )}

          {/* 배달 최소금액 도달 토스트 */}
          {deliveryToast && (
            <div style={{
              position: 'fixed', bottom: '90px', left: '50%', transform: 'translateX(-50%)',
              background: '#1b5e20', color: 'white', padding: '13px 22px',
              borderRadius: '30px', fontWeight: 'bold', fontSize: '0.92rem',
              zIndex: 9999, boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
              whiteSpace: 'nowrap', animation: 'fadeInUp 0.3s ease'
            }}>
              {deliveryToast}
            </div>
          )}
        </>
      )}

      {/* 결제 방식 선택 모달 */}
      {showPaymentModal && (
        <div id="paymentModal" style={{
          display: 'flex', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.7)', zIndex: 10000, alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{ background: 'white', width: '90%', maxWidth: '400px', padding: '25px', borderRadius: '25px', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
            <h3 style={{ textAlign: 'center', marginBottom: '20px', color: '#333' }}>결제 방식을 선택해주세요</h3>
            <div onClick={copyAccount} style={{ background: '#fff9f9', padding: '20px', borderRadius: '18px', border: '2px dashed #ff4500', cursor: 'pointer', textAlign: 'center', marginBottom: '15px' }}>
              <span style={{ display: 'inline-block', background: '#008485', color: 'white', padding: '4px 10px', borderRadius: '6px', fontSize: '12px', marginBottom: '8px' }}>하나은행 (계좌이체)</span>
              <h4 style={{ margin: 0, fontSize: '19px', color: '#111' }}>743-910273-51707</h4>
              <p style={{ margin: '5px 0 0 0', fontSize: '15px', fontWeight: 'bold', color: '#444' }}>예금주: 신전떡볶이 홍성점</p>
              <p style={{ marginTop: '10px', fontSize: '12px', color: '#ff4500' }}>👆 터치하면 계좌번호가 복사됩니다</p>
            </div>
            <button onClick={cardPaymentAlert} style={{ width: '100%', padding: '18px', background: '#333', color: 'white', border: 'none', borderRadius: '15px', fontSize: '17px', fontWeight: 'bold', cursor: 'pointer', marginBottom: '10px' }}>
              💳 {(orderType === 'delivery' || orderType === 'takeout-reservation') ? '(만나서) 카드 결제' : '카드 결제 (조리 후 카운터에서)'}
            </button>
            <button onClick={cashPaymentAlert} style={{ width: '100%', padding: '18px', background: '#ed1c24', color: 'white', border: 'none', borderRadius: '15px', fontSize: '17px', fontWeight: 'bold', cursor: 'pointer', marginBottom: '10px' }}>
              💵 {(orderType === 'delivery' || orderType === 'takeout-reservation') ? '(만나서) 현금 결제' : '현금 결제 (조리 후 카운터에서)'}
            </button>
            <p onClick={closeModal} style={{ textAlign: 'center', color: '#999', cursor: 'pointer', textDecoration: 'underline', fontSize: '14px', marginTop: '15px' }}>취소하고 메뉴 더보기</p>
          </div>
        </div>
      )}

      {/* 주문접수 완료 모달 */}
      {showOrderConfirm && (
        <div style={{
          display: 'flex', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.75)', zIndex: 11000, alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{ background: 'white', width: '88%', maxWidth: '380px', padding: '32px 24px', borderRadius: '24px', textAlign: 'center', boxShadow: '0 12px 40px rgba(0,0,0,0.3)' }}>
            <div style={{ fontSize: '3rem', marginBottom: '12px' }}>✅</div>
            <h3 style={{ color: 'var(--main-red)', fontSize: '1.3rem', marginBottom: '10px' }}>주문이 접수되었습니다!</h3>
            <div style={{ background: '#fff8f0', border: '1.5px solid #ffd8a8', borderRadius: '14px', padding: '16px', margin: '16px 0', fontSize: '0.95rem', color: '#555', lineHeight: '1.7' }}>
              <div style={{ fontSize: '1.6rem', marginBottom: '6px' }}>📱</div>
              <strong style={{ color: '#333', fontSize: '1rem' }}>주문 접수는 문자로 확인하세요</strong>
            </div>
            <button
              className="btn-main"
              onClick={() => { setShowOrderConfirm(false); setLastOrderType(null); setOrderType(null); setLastOrderNo(null); localStorage.removeItem('lastOrderNo'); }}
              style={{ width: '100%', fontSize: '1.05rem', padding: '16px' }}
            >
              확인
            </button>
          </div>
        </div>
      )}

      {/* 원산지 정보 모달 */}
      {showOriginModal && (
        <div className="modal-overlay" style={{ zIndex: 9000 }}>
          <div className="modal-content" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
            <h2 style={{ textAlign: 'center', color: 'var(--main-red)', marginBottom: '5px' }}>📋 원산지 표시</h2>
            <p style={{ textAlign: 'center', fontSize: '0.8rem', color: '#888', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '15px' }}>
              식품위생법에 따른 원산지 표시입니다
            </p>
            {originInfo ? (
              <div style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem', lineHeight: '1.8', color: '#333', padding: '5px 0' }}>{originInfo}</div>
            ) : (
              <div style={{ textAlign: 'center', color: '#aaa', padding: '30px 0', fontSize: '0.9rem' }}>원산지 정보가 아직 등록되지 않았습니다.</div>
            )}
            <button className="btn-main" style={{ marginTop: '20px' }} onClick={() => setShowOriginModal(false)}>닫기</button>
          </div>
        </div>
      )}

      {/* 앱 설치 유도 배너 */}
      {showInstallBanner && (
        <div className="install-banner">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '44px', height: '44px', borderRadius: '10px', overflow: 'hidden', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}>
              <img src="img/1280_1280_떡볶이_흰색.webp" style={{ width: '90%', height: '90%', objectFit: 'contain' }} />
            </div>
            <div style={{ lineHeight: '1.4' }}>
              <div style={{ fontWeight: 'bold', fontSize: '0.95rem', color: '#fff' }}>신전 홍성점 앱 설치</div>
              <div style={{ fontSize: '0.75rem', color: '#ccc' }}>홈 화면에 추가하고 편하게 주문하세요!</div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px', marginLeft: '10px' }}>
            <button onClick={() => setShowInstallBanner(false)} style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '0.8rem', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap' }}>나중에</button>
            <button onClick={handleInstall} style={{ background: 'var(--main-red)', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '10px', fontWeight: 'bold', fontSize: '0.85rem', cursor: 'pointer', whiteSpace: 'nowrap', boxShadow: '0 4px 12px rgba(237, 28, 36, 0.3)' }}>홈추가</button>
          </div>
        </div>
      )}
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
